import ProfileEditForm from '../../../components/pages/mypages/ProfileEditForm.vue'

export default {
  components: {
    ProfileEditForm
  }
}
